import { useEffect } from "react";

import { InitialOrderDataPart, LabelPrint, OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// Hook listens for changes of starting country field
// and reloads countries to list depending on new value

const usePickupTimeFramesLoader = (): void => {
  const { values } = useOrderFormik();

  const { loadedInitialData, updatePickupTimeFrames } = useOrderData();

  const countryFrom = values[OrderFields.STARTING_COUNTRY] || undefined;
  const senderZipCode = values[OrderFields.SENDER_ZIP_CODE] || undefined;
  const isLabelPrintByCourier = values[OrderFields.LABEL_PRINT] === LabelPrint.COURIER;

  const isPrefillDataLoaded = loadedInitialData[InitialOrderDataPart.PREFILL_VALUES];

  useEffect(() => {
    if (!isPrefillDataLoaded) {
      return;
    }
    updatePickupTimeFrames({ countryFrom, senderZipCode, isLabelPrintByCourier });
  }, [countryFrom, isLabelPrintByCourier, isPrefillDataLoaded, senderZipCode, updatePickupTimeFrames]);
};
export default usePickupTimeFramesLoader;
